import { $ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-article-actions]')) return;

  showShareOptions();
}

function showShareOptions() {
  const buttonShare = $('[data-au-article-actions-btn-share]');
  const buttonShareIcon = buttonShare.querySelector('[data-au-icon]');
  const shareActions = $('[data-au-article-actions-share]');
  const shareLinks = shareActions.querySelectorAll('[data-au-socialize-link], [data-au-download-file]');
  const buttonDownload = $('[data-au-article-download]');
  const buttonShareDownload = $('[data-au-article-actions-share] [data-au-download-file]');
  const footerLike = $('[data-au-article-footer] [data-au-article-footer-like]');

  if (buttonDownload) {
    buttonShareDownload?.classList.add('au-hide');
    footerLike?.classList.add('au-hide');

    buttonDownload.addEventListener('click', (e) => {
      e.preventDefault();
      const el = e.currentTarget;
      if (!el.closest('[data-au-article]')) return;
      const titleText = el.closest('[data-au-article]').querySelector('[data-au-title]')
        ? el.closest('[data-au-article]').querySelector('[data-au-title]').innerText
        : '';
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)} ok`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickDescarga',
        item_id,
      });
    });
  } else {
    buttonShareDownload?.classList.remove('au-hide');
    footerLike?.classList.remove('au-hide');
  }

  buttonShare.addEventListener('click', (e) => {
    e.preventDefault();
    if (buttonShareIcon.textContent === 'more_vert') {
      buttonShareIcon.textContent = 'close';
      shareActions.classList.add('au-article-actions__share-container--opened');
      // remove tabindex from rrss links
      shareLinks.forEach((link) => {
        link.removeAttribute('tabindex');
      });
    } else {
      buttonShareIcon.textContent = 'more_vert';
      shareActions.classList.remove('au-article-actions__share-container--opened');
      // add tabindex -1 to rrss links
      shareLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }

    const el = e.currentTarget;
    if (!el.closest('[data-au-article]')) return;
    const titleText = el.closest('[data-au-article]').querySelector('[data-au-title]')
      ? el.closest('[data-au-article]').querySelector('[data-au-title]').innerText
      : '';
    const clickText = el.querySelector(':not([data-au-icon])').innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickIcono',
      item_id,
    });
  });

  document.addEventListener('click', (event) => {
    if (!shareActions.contains(event.target) && event.target !== buttonShare) {
      buttonShareIcon.textContent = 'more_vert';
      shareActions.classList.remove('au-article-actions__share-container--opened');
      // add tabindex -1 to rrss links
      shareLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }
  });

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      buttonShareIcon.textContent = 'more_vert';
      shareActions.classList.remove('au-article-actions__share-container--opened');

      // add tabindex -1 to rrss links
      shareLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });

      // focus on share button when close rrss dropdown
      buttonShare.focus();
    }
  });
}

export default { init };
